export enum LOG_TYPE {
  OPERATE_LOG = 'operateLog',
  SYSTEM_LOG = 'systemLog',
  ERROR_LOG = 'errorLog'
}

export const logTypeOptions = [
  { label: '操作日志', value: LOG_TYPE.OPERATE_LOG },
  { label: '系统日志', value: LOG_TYPE.SYSTEM_LOG },
  { label: '错误日志', value: LOG_TYPE.ERROR_LOG }
]

export const logDescMap = new Map([
  [LOG_TYPE.OPERATE_LOG, '操作日志为客户端日志'],
  [LOG_TYPE.SYSTEM_LOG, '系统日志为中心服务端日志'],
  [LOG_TYPE.ERROR_LOG, '错误日志为客户端日志']
])

export const logColumnsMap = new Map([
  [
    LOG_TYPE.OPERATE_LOG,
    [
      {
        title: '序号',
        dataIndex: 'id',
        render: (_text, _record, index) => index + 1,
        width: 80
      },
      {
        title: '操作日期',
        dataIndex: 'operDate'
      },
      {
        title: '操作时间',
        dataIndex: 'operTime'
      },
      {
        title: '机构',
        dataIndex: 'orgName'
      },
      {
        title: '门店',
        dataIndex: 'storeName'
      },
      {
        title: '设备',
        dataIndex: 'devName'
      },
      {
        title: 'IP',
        dataIndex: 'ipAddr'
      },
      {
        title: '操作分类',
        dataIndex: 'operType'
      },
      {
        title: '操作',
        dataIndex: 'operContent'
      },
      {
        title: '操作状态',
        dataIndex: 'operStatus',
        render: (text) => (
          <span
            className={
              text === '成功'
                ? 'enable-span'
                : text === '失败'
                ? 'disable-span'
                : ''
            }>
            {text}
          </span>
        )
      }
    ]
  ],
  [
    LOG_TYPE.SYSTEM_LOG,
    [
      {
        title: '序号',
        dataIndex: 'id',
        render: (_text, _record, index) => index + 1,
        width: 80
      },
      {
        title: '操作日期',
        dataIndex: 'operDate'
      },
      {
        title: '操作时间',
        dataIndex: 'operTime'
      },
      {
        title: '操作账户',
        dataIndex: 'operName'
      },
      {
        title: 'IP',
        dataIndex: 'ipAddr'
      },
      {
        title: '操作分类',
        dataIndex: 'operType'
      },
      {
        title: '操作',
        dataIndex: 'operContent'
      },
      {
        title: '操作状态',
        dataIndex: 'operStatus',
        render: (text) => (
          <span
            className={
              text === '成功'
                ? 'enable-span'
                : text === '失败'
                ? 'disable-span'
                : ''
            }>
            {text}
          </span>
        )
      }
    ]
  ],
  [
    LOG_TYPE.ERROR_LOG,
    [
      {
        title: '序号',
        dataIndex: 'id',
        render: (_text, _record, index) => index + 1,
        width: 80
      },
      {
        title: '操作日期',
        dataIndex: 'operDate'
      },
      {
        title: '操作时间',
        dataIndex: 'operTime'
      },
      {
        title: '机构',
        dataIndex: 'orgName'
      },
      {
        title: '门店',
        dataIndex: 'storeName'
      },
      {
        title: '设备',
        dataIndex: 'devName'
      },
      {
        title: 'IP',
        dataIndex: 'ipAddr'
      },
      // {
      //   title: '错误编号',
      //   dataIndex: 'errorCode'
      // },
      {
        title: '错误简介',
        dataIndex: 'errdes'
      },
      {
        title: '错误详情',
        dataIndex: 'errContent'
      }
    ]
  ]
])
